var map = {
	"./404.png": "e412",
	"./basic/footer/icon.png": "95e9",
	"./basic/footer/title.png": "8d1c",
	"./basic/navbar/icon.png": "d240",
	"./basic/navbar/title.png": "07f7",
	"./bg.png": "0a1d",
	"./icon/about.png": "997f",
	"./icon/banner.png": "8a1e",
	"./icon/bx1.png": "d031",
	"./icon/bx2.png": "e443",
	"./icon/bx3.png": "3fc3",
	"./icon/bx4.png": "c489",
	"./icon/shield.png": "a82d",
	"./icon/sport.png": "7a49",
	"./icon/thumb.png": "00b0",
	"./insure/bg.png": "3f56",
	"./insure/compensate.png": "39d1",
	"./my/insure/bl.jpeg": "92c6",
	"./my/insure/dzbd.png": "1b07",
	"./my/insure/kjfp.png": "ae82",
	"./my/insure/sqlp.png": "dfd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8a4";